import { StaffProgressTable, StaffProgressHeaderActionType } from "ft-shared-graphql/components/Tables";
import { useNavigate, useParams } from "react-router";
import { useEffect, useState } from "react";
import { useCompany } from "../../context/CompanyContext";
import { HeaderActionType, useManageModal, ApiValidationError, mapApiFieldValidationErrors } from "ui";
import { useMutation, useQuery } from "@apollo/client";
import { format } from "date-fns"
import { ADD_STAFF_FORM_FIELDS, AddStaffFormSchema, addPerformValidationSchema, ADD_USER, useSlideInContext } from "ft-shared-graphql";
import { ADD_PERSON_MUTATION, GET_PEOPLE_WITH_SESSION_COUNT, GET_ROLES } from "ft-shared-graphql";
import { AddPersonMutation, AddPersonMutationVariables, GetRolesQuery, PersonRole } from "../../__generated__/graphql";
import { Add } from "@mui/icons-material";
import usePersonStore from "../store/personStore";
export const StaffProgressPage = ({ onBack, onSelectedPerson }: ({ onBack: () => void, onSelectedPerson: (id: string, action: string) => void })) => {
    const { cid } = useParams()
    const { toggleDrawer, handleContent } = useSlideInContext()
    const { openModal } = useManageModal()
    const { company } = useCompany(cid)
    const [addPerson] = useMutation<AddPersonMutation, AddPersonMutationVariables>(ADD_PERSON_MUTATION, {
        refetchQueries: [GET_PEOPLE_WITH_SESSION_COUNT]
    })
    const [roleOptions, setRoleOptions] = useState<any[]>([]);
    const myId = usePersonStore(state => state.id);

    const handleAction = (action: StaffProgressHeaderActionType) => {

    }
    const { loading: roleLoading, data: roleData } = useQuery<GetRolesQuery>(GET_ROLES)
    useEffect(() => {
        if (!roleData?.roles) return;
        setRoleOptions(roleData?.roles);
        console.log("the role data: ", roleData?.roles)
    }, [roleData?.roles])
    const handleAddNewUser = () => {
        handleContent(ADD_USER, {
            roles: roleOptions,
            locations: company?.locations,
            staffFormFields: ADD_STAFF_FORM_FIELDS,
            validatorSchema: addPerformValidationSchema,
            onSubmit: async (values: AddStaffFormSchema) => {
                await createNewUser(values)
                toggleDrawer()
            }
        })
    }

    const createNewUser = async (values: AddStaffFormSchema) => {
        const response = await addPerson({
            variables: {
                firstName: values.firstName,
                middleName: values.middleName,
                lastName: values.lastName,
                role: values.roleType as PersonRole,
                email: values.email,
                companyId: cid,
                locationIds: values.location,
                startDate: format(new Date(), 'yyyy-MM-dd')
            },
            onError(error, clientOptions) {
                openModal({ type: "GENERAL_ERROR" })
            }
        });

        // If type of "ValidationError" exists in the errors payload field
        // map errors to dicitonary and return. Final form will then 
        // render the errors to the each stated field
        // Note: must match form definition
        if (response.data?.addPerson.errors) {
            const validationError = response.data.addPerson.errors
                .find(e => e.__typename === "ValidationError") as ApiValidationError;
            const businessRuleError = response.data.addPerson.errors
                .find(e => e.__typename === "EntityBusinessRuleError") as ApiValidationError;
            if (validationError) {
                const fieldErrors = validationError
                    ? mapApiFieldValidationErrors(validationError)
                    : null;

                return fieldErrors;
            } else if (businessRuleError) {
                openModal({ type: "USER_CAP" })
            } else {
                openModal({ type: "GENERAL_ERROR" })
            }
        }

        toggleDrawer();
    };

    const headerActions: HeaderActionType[] = [{
        name: "Add new User",
        icon: <Add />,
        action: handleAddNewUser,
    },

    ]
    return (
        <div>
            <StaffProgressTable
                headerActions={headerActions}
                onHeaderAction={handleAction}
                company={company} onBack={onBack}
                myId={myId}
                onSelectedPerson={onSelectedPerson} />
        </div>
    )
}
export default StaffProgressPage